export const SET_LOGS = 'SET_LOGS';
export const SET_ERRORS = 'SET_ERRORS';
